<template>
  <nav class="subnav">
    <RouterLink
      v-for="city in cities"
      :key="city"
      custom
      :to="buildTo(city)"
      v-slot="{ href, navigate, isActive }"
    >
      <a
        :href="href"
        class="chip"
        :class="{ 'chip--active': isActive }"
      >
        {{ pretty(city) }}
      </a>
    </RouterLink>
  </nav>
</template>

<script>
export default {
  name: 'CitySubnav',
  props: {

    cities: { type: Array, required: true },
    // Optional: build a custom destination. Default -> '/<city>'
    // You can pass a function (city) => ({ name: 'portfolio-place', params: { place: city } })
    to: { type: [Function, String], default: null }
  },
  methods: {
    buildTo(city) {
      if (typeof this.to === 'function') return this.to(city)
    // default path style: '/amsterdam'
    let city2 = city.replace(/\s+/g, '');
      return `/portfolio/${city2}`
    },
    pretty(city) {
    
      return city.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
    }
  }
}
</script>

<style scoped>
.subnav {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); /* even fill */
  gap: .5rem;
  margin: .25rem 0 1rem;
}

.chip {
  display: inline-flex;
  width: 100%;                 /* stretch to column width */
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  padding: .5rem .75rem;
  font-size: .875rem;
  line-height: 1;

/* light orange on white */

/*
background: #ffefc9;
*/

 /*border: 1px solid #ffd88a; */  /* subtle edge */
/*
  color: #3a2300;
*/

  text-decoration: none;
  transition: background .15s ease, box-shadow .15s ease, color .15s ease;
}
.chip:hover { background: #ffe4ad; }     /* a touch darker */
.chip:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #ffc85f;
}
.chip--active {
  background: #ffc85f;         /* medium orange – still light */
  border-color: #ffac1c;       /* your header orange */
  color: #2a1900;              /* readable on the fill */
}
</style>
